// API URL Configuration
// Can be overridden with REACT_APP_API_URL environment variable
// Default: Production API
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.theskillgenie.com";
const CLOUDFRONT_URL = "https://d1atm4dw3zgpab.cloudfront.net";

export { API_BASE_URL, CLOUDFRONT_URL };
export default API_BASE_URL;



